export default __webpack_public_path__ + "static/media/marosa.2983aff0.jpg";